import { NgModule } from "@angular/core";
import { AsyncPipe, CommonModule, NgTemplateOutlet } from "@angular/common";
import { ErrorViewComponent } from "./error-view/error-view.component";
import { InputToggleComponent } from "./input-toggle/input-toggle.component";
import { InputComponent } from "./input/input.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "@app/shared/shared.module";
import { TableComponent } from "./table/table.component";
import { FileUploadComponent } from "./file-upload/file-upload.component";
import { InputDropdownComponent } from "./input-dropdown/input-dropdown.component";
import { PageViewNavComponent } from "./page-view-nav/page-view-nav.component";
import { RouterModule } from "@angular/router";
import { CodeViewerComponent } from "./code-viewer/code-viewer.component";
import { DateModalComponent } from "./date-modal/date-modal.component";
import { FrameworkModule } from "@app/framework/framework.module";
import { FileExplorerComponent } from "./file-explorer/file-explorer.component";
import { InputAutocompleteComponent } from "./input-autocomplete/input-autocomplete.component";
import { TourBubbleComponent } from "./tour-bubble/tour-bubble.component";
import { LoadingDotsComponent } from "./loading-dots/loading-dots.component";
import { InputDateComponent } from "./input-date/input-date.component";
import { InputPillComponent } from "./input-pill/input-pill.component";
import { ButtonComponent } from "./button/button.component";
import { IntegrationStatusModalComponent } from "./integration-status-modal/integration-status-modal.component";
import { IntegrationPermissionsComponent } from "./integration-status-modal/integration-permissions/integration-permissions.component";
import { LoadingPlaceholderComponent } from "./loading-placeholder/loading-placeholder.component";
import { InputToggleIconComponent } from "./input-toggle-icon/input-toggle-icon.component";
import { FileExplorerInputComponent } from "./file-explorer-input/file-explorer-input.component";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpLoaderFactory } from "@app/app.module";
import { HttpClient } from "@angular/common/http";
import { ButtonMultiSelectComponent } from "./button-multi-select/button-multi-select.component";
import { CodeEditorComponent } from "./code-editor/code-editor.component";
import { InputTextareaComponent } from "./input-textarea/input-textarea.component";
import { InputToggleSmallComponent } from "./input-toggle-small/input-toggle-small.component";
import { InputCheckboxComponent } from "./input-checkbox/input-checkbox.component";
import { InputRadioComponent } from "./input-radio/input-radio.component";
import { TabsComponent } from "./tabs/tabs.component";
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ProcessingViewComponent } from "./processing-view/processing-view.component";
import { PrimengModule } from "@app/shared/primeng.module";



@NgModule({
  declarations: [
    ProcessingViewComponent,
    InputCheckboxComponent,
    TabsComponent,
    InputToggleSmallComponent,
    FileExplorerComponent,
    ErrorViewComponent,
    InputToggleComponent,
    InputComponent,
    TableComponent,
    FileUploadComponent,
    InputDropdownComponent,
    DateModalComponent,
    PageViewNavComponent,
    CodeViewerComponent,
    InputAutocompleteComponent,
    TourBubbleComponent,
    LoadingDotsComponent,
    InputDateComponent,
    InputPillComponent,
    ButtonComponent,
    IntegrationStatusModalComponent,
    LoadingPlaceholderComponent,
    InputToggleIconComponent,
    TourBubbleComponent,
    FileExplorerInputComponent,
    ButtonMultiSelectComponent,
    CodeEditorComponent,
    InputTextareaComponent,
    InputRadioComponent,
    IntegrationPermissionsComponent
  ],
  imports: [
    PrimengModule,
    ScrollingModule,
    FrameworkModule,
    NgTemplateOutlet,
    AsyncPipe,
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    ProcessingViewComponent,
    InputRadioComponent,
    InputCheckboxComponent,
    TabsComponent,
    InputToggleSmallComponent,
    InputAutocompleteComponent,
    FileExplorerComponent,
    InputToggleIconComponent,
    LoadingPlaceholderComponent,
    IntegrationStatusModalComponent,
    ButtonComponent,
    InputPillComponent,
    InputDateComponent,
    LoadingDotsComponent,
    InputTextareaComponent,
    CodeEditorComponent,
    ButtonMultiSelectComponent,
    PageViewNavComponent,
    CodeViewerComponent,
    DateModalComponent,
    ErrorViewComponent,
    InputToggleComponent,
    InputComponent,
    TableComponent,
    FileUploadComponent,
    InputDropdownComponent,
    FileExplorerInputComponent,
    IntegrationPermissionsComponent,  
  ],
})
export class GenericModule {}
